import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RESPONSE_API_URL } from "config";
const brand = process.env.REACT_APP_BRAND_TYPE ?? "boxphish";

const baseQuery = fetchBaseQuery({
    baseUrl: RESPONSE_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');

        if (user) {
            let userToken = JSON.parse(user).token;
            headers.set('authorization', `Bearer ${userToken}`)
        }
        return headers
    },
    credentials: "omit"
})

export const reportApi = createApi({
    reducerPath: "reportApi",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getExcelReportSettings: builder.query({
            query: ({tenancyId}) => `excelreportsettings/${tenancyId}`,
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),
        sendExcelReportSettings: builder.mutation({
            query: ({tenancyId, data}) => ({
                url:`excelreportsettings/${tenancyId}`,
                method: 'PUT',
                body: data,
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),
        sendGenerateExcelReport: builder.mutation({
            query: ({tenancyId, data}) => ({
                url:`excelreport/${tenancyId}`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),
        getSimulationDataByTenancyId: builder.query({
            query: ({ tenancyId, startDate, endDate }) => {
                let url = `data/${tenancyId}/simulation`;

                const params = new URLSearchParams();
                if (startDate) params.append('start', startDate); 
                if (endDate) params.append('end', endDate);

                if (params.toString()) {
                    url += `?${params.toString()}`;
                }

                return url;
            },
            transformResponse: (response) => response
        }),

        getDataByUserId: builder.query({
            query: ({ tenancyId, userId, startDate, endDate }) => {
                let url = `data/${tenancyId}/user/${userId}`;

                // Add query parameters if dates are provided
                const params = new URLSearchParams();
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);

                if (params.toString()) {
                    url += `?${params.toString()}`;
                }

                return url;
            },
            transformResponse: (response) => response
        }),

        getDepartmentAnalytics: builder.query({
            query: ({ tenancyId, startDate, endDate }) => {
                let url = `analytics/departments/${tenancyId}`;
                const params = new URLSearchParams();
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);
                if (params.toString()) {
                    url += `?${params.toString()}`;
                }
                return url;
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),

        getLineManagerAnalytics: builder.query({
            query: ({ tenancyId, startDate, endDate, lineManagerId, includeHierarchy }) => {
                let url = `analytics/line-managers/${tenancyId}`;
                const params = new URLSearchParams();
                if (startDate) params.append('startDate', startDate);
                if (endDate) params.append('endDate', endDate);
                if (lineManagerId) params.append('lineManagerId', lineManagerId);
                if (includeHierarchy) params.append('includeHierarchy', 'true');
                if (params.toString()) {
                    url += `?${params.toString()}`;
                }
                return url;
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),
    })
});

export const {
    useGetExcelReportSettingsQuery,
    useSendExcelReportSettingsMutation,
    useSendGenerateExcelReportMutation,
    useGetSimulationDataByTenancyIdQuery,
    useGetDataByUserIdQuery,
    useGetDepartmentAnalyticsQuery,
    useGetLineManagerAnalyticsQuery
} = reportApi;